import React, { useState } from 'react';

export default function NotificationsTab() {
  const [preferences, setPreferences] = useState({
    pushNewMessage: true,
    pushSlaBreach: true,
    emailUnassigned: false,
    unassignedMinutes: 15
  });

  const handleSave = () => {
    // In a real app, save to agent's user document
    alert('Preferences saved');
  };

  return (
    <div className="max-w-lg space-y-6">
      <h3 className="text-white font-medium mb-4">Notification Preferences</h3>
      
      <div className="space-y-4">
        <h4 className="text-sm font-medium text-wa-muted border-b border-wa-border pb-1">Web Push (FCM)</h4>
        
        <label className="flex items-center space-x-3 text-white">
          <input 
            type="checkbox" 
            checked={preferences.pushNewMessage}
            onChange={e => setPreferences({...preferences, pushNewMessage: e.target.checked})}
            className="rounded border-wa-border bg-wa-surface focus:ring-wa-green text-wa-green"
          />
          <span className="text-sm">New message in assigned conversation</span>
        </label>
        
        <label className="flex items-center space-x-3 text-white">
          <input 
            type="checkbox" 
            checked={preferences.pushSlaBreach}
            onChange={e => setPreferences({...preferences, pushSlaBreach: e.target.checked})}
            className="rounded border-wa-border bg-wa-surface focus:ring-wa-green text-wa-green"
          />
          <span className="text-sm">SLA breach on assigned conversation</span>
        </label>
      </div>

      <div className="space-y-4 pt-4">
        <h4 className="text-sm font-medium text-wa-muted border-b border-wa-border pb-1">Email Alerts</h4>
        
        <label className="flex items-center space-x-3 text-white">
          <input 
            type="checkbox" 
            checked={preferences.emailUnassigned}
            onChange={e => setPreferences({...preferences, emailUnassigned: e.target.checked})}
            className="rounded border-wa-border bg-wa-surface focus:ring-wa-green text-wa-green"
          />
          <span className="text-sm">Alert me of old unassigned conversations</span>
        </label>
        
        {preferences.emailUnassigned && (
          <div className="pl-7 flex items-center space-x-2">
            <span className="text-sm text-wa-muted">After</span>
            <input 
              type="number" 
              value={preferences.unassignedMinutes}
              onChange={e => setPreferences({...preferences, unassignedMinutes: parseInt(e.target.value) || 0})}
              className="w-16 bg-wa-surface border border-wa-border rounded text-white p-1 text-center text-sm"
            />
            <span className="text-sm text-wa-muted">minutes</span>
          </div>
        )}
      </div>

      <button 
        onClick={handleSave} 
        className="bg-wa-green text-gray-900 px-4 py-2 rounded font-medium mt-4"
      >
        Save Preferences
      </button>
    </div>
  );
}
